import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})

export class ResidentService {

    public currentWaiver = new Subject<any>();
    private waiver_vehicle_id: string;
    constructor(private httpClient: HttpClient) { }

    setCurrentWaiver(waiver: any) {
        // this.waiver_vehicle_id = waiver.waiver_vehicle_id;
        this.currentWaiver = waiver;
    }
    getCurrentWaiver() {
        return this.currentWaiver;
    }

    //Service changes added
    getParkingReason(): Observable<any> {
        return this.httpClient.get('api/reason/get').pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }

    saveWaiverDetail(data): Observable<any> {
        return this.httpClient.post('api/user/create',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    fetchWaiverDetail(data): Observable<any> {
        return this.httpClient.get(`api/user/search?email=${data}`)
            .pipe(
                map((body: any) => {
                    return body;
                })
            );
    }


    submitParkingDetails(data) {
        return this.httpClient.post('api/parking/createParkingWaiver',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    get(plateNo, userSelectedYear,startDate): Observable<any> {
        let params: any = {};
        params.plateNo = plateNo;
        params.userSelectedYear = userSelectedYear;
        params.startDate = startDate;
        return this.httpClient.get('api/enforcement/get',
            { params: params })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    sendApprovedMail(data): Observable<any> {
        return this.httpClient.post('api/waiver/sendApprovedMail',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })

            );
    }
    sendNotApprovedMail(data): Observable<any> {
        return this.httpClient.post('api/waiver/sendNotApprovedMail',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                    } else {
                        return body;
                    }
                })
            );
    }

    checkToken(data): Observable<any> {
        return this.httpClient.get(`api/waiver/auth/${data}`)
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        return body
                        //  throw new Error('error');
                    } else {
                        return body;

                    }
                })
            );
    }
}